import { render } from "./Detail.vue?vue&type=template&id=40516792&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=40516792&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-40516792"

export default script